import React from 'react';
import { Container, ListGroup, ListGroupItem, Button } from 'reactstrap';
import tickImg from './tick.svg';

const ListBox = ({currentQuestion, listBoxClickHandler, selectedOption, onClickClose}) => {
    const findSelectedOption = selectedOption?.find(obj => obj.name === currentQuestion.name);
    return (
        <Container>
            <ListGroup flush className='que-list-group'>
                {currentQuestion.options.map((obj, i) => <ListGroupItem key={obj.value} onClick={() => listBoxClickHandler(obj.value)}>{obj.label}
                    { findSelectedOption && findSelectedOption.option.includes(obj.value) && <img className='float-end' src={tickImg} alt="" /> }
                </ListGroupItem>)}
            </ListGroup>
            { currentQuestion.name !== 'medication' && <Button className="risk-btn mb-4" onClick={onClickClose}>Done</Button> }
        </Container>
    );
};

export default ListBox;